import { Injectable } from '@angular/core';
import { environment } from "../environments/environment";
import { Http, Response } from "@angular/http";
import { AuthHttp } from 'angular2-jwt';
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";


@Injectable()
export class HomeApiService {

  constructor(
    private homeApi : Http,
    private authHTTP: AuthHttp
  ) { }

  GetMenuFromApi(){
    return this.authHTTP.get(environment.apiEndPoint + `/Home`)
      .map((response : Response) => response.json())
  }

  GetUserProfile(){
    return this.authHTTP.get(environment.apiEndPoint + `/Home/Profile`)
      .map((response : Response) => response.json())
  }

  GetTokenFromBodesApi(callbackKey){
    return this.homeApi.get(environment.apiEndPoint + `/idsvr/callback/` + callbackKey)
      .map((response : Response) => response.json())
  }
}



// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/data/HomeApi.service.ts